export enum NewbornIPPEncounterQuestionnaireNames {
  BirthDetails = "newborn-ipp-birth-details",
  Size = "newborn-ipp-size",
  VitalsSign = "newborn-ipp-vitals-sign",
  Feeding = "newborn-ipp-feeding",
  MedicationsTherapies = "newborn-ipp-medication-and-therapies",
  GestationalAge = "newborn-ipp-gestational-age",
  Encounter = "newborn-ipp-encounter",
}

export enum NewbornIPPVitalsSignQuestionsLinkIds {
  Date = "newbornIPPVitalsSignDate",
  Time = "newbornIPPVitalsSignTime",
  HeartRate = "newbornIPPVitalsSignHeartRate",
  RespiratoryRate = "newbornIPPVitalsSignRespiratoryRate",
  Temperature = "newbornIPPVitalsSignTemperature",
  TemperatureUnit = "newbornIPPVitalsSignTemperatureUnit",
  TemperatureMethod = "newbornIPPVitalsSignTemperatureMethod",
  Color = "newbornIPPVitalsSignColor",
  Void = "newbornIPPVitalsSignVoid",
  Stool = "newbornIPPVitalsSignStool",
  Notes = "newbornIPPVitalsSignNotes",
}

export enum NewbornIPPBirthDetailsQuestionsLinkIds {
  Sex = "birthDetailsSex",
  SexSpecify = "birthDetailsSexSpecify",
  BabyName = "birthDetailsBabyName",
}

export enum NewbornIPPSizeQuestionsLinkIds {
  Scale = "sizeScale",
  Weight = "sizeWeight",
  WeightOunces = "sizeWeightOunces",
  Length = "sizeLength",
  HeadCircumference = "sizeHeadCircumference",
  ChestCircumference = "sizeChestCircumference",
  Notes = "sizeNotes",
}

export enum NewbornIPPFeedingQuestionsLinkIds {
  Nursing = "nursing",
  Formula = "formula",
  Notes = "notes",
}

export enum NewbornIPPMedicationsTherapiesQuestionsLinkIds {
  VitaminK = "vitaminK",
  EyeProphylaxis = "eyeProphylaxis",
  HepatitisB = "hepatitisB",
  VitaminKDose = "vitaminKDose",
  VitaminKLotNumber = "vitaminKLotNumber",
  VitaminKNotes = "vitaminKNotes",
  EyeProphylaxisNotes = "eyeProphylaxisNotes",
  HepatitisBNotes = "hepatitisBNotes",
}

export enum NewbornIPPMedicationAndTherapiesStatus {
  Administered = "administered",
  Decline = "decline",
}

export enum NewbornIPPGestationalAgeQuestionsLinkIds {
  GestationalAge = "gestationalAge",
  GestationalAgeBallardScore = "gestationalAgeBallardScore",
  GestationalAgeFromLMP = "gestationalAgeFromLMP",
}

export enum NewbornIPPEncounterDrawerActions {
  Save = "save",
  SignAndLock = "signAndLock",
}

/**
 * Numeric input bounds for Newborn IPP forms.
 * Keep aligned with qh-newborn-ipp-*.json seed questionnaires (maxValue extensions)
 * and any matching DrawerNumberInput max props.
 */
export const NewbornIPPBounds = {
  gestationalAge: { min: 0, max: 99 },
  ballardScore: { min: -10, max: 50 },
  size: {
    weightImperialMax: 999,
    weightMetricMax: 99999,
    ozMax: 999,
    lengthMax: 999,
    headCircumferenceMax: 999,
    chestCircumferenceMax: 999,
  },
  vitals: {
    heartRateMax: 999,
    respiratoryRateMax: 999,
    temperatureMax: 999,
  },
} as const;

export enum NewbornIPPEncounterQuestionsLinkIds {
  EncounterNote = "notes",
  EncounterTemplate = "encounterTemplate",
  EncounterType = "encounterType",
  EncounterLocation = "encounterLocation",
  EncounterAmendmentInfoReason = "encounterAmendmentInfoReason",
  EncounterAmendmentInfoSpecify = "encounterAmendmentInfoSpecify",
  EncounterAmendmentInfoNotes = "encounterAmendmentInfoNotes",
  EncounterAmendmentInfoNotifyClient = "encounterAmendmentInfoNotifyClient",
  EncounterDiagnosisCode = "encounterClientDiagnosisCode",
  EncounterDiagnosisAddToProblemList = "encounterClientDiagnosisAddToProblemList",
  EncounterDiagnosisNotes = "encounterClientDiagnosisNotes",
}
